import { useState } from 'react'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import PersonIcon from '@mui/icons-material/Person'
import HeaderSearchOption from './HeaderSearchOption'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined'
import { AutocompleteRenderGroupParams } from '@mui/material/Autocomplete'

import { HeaderSearchAssetType } from '../../enums/enums'

type ComponentProps = {
  data: AutocompleteRenderGroupParams
}

const PREFIX = 'HeaderSearchGroup'

const classes = {
  group: `${PREFIX}-group`,
  showMore: `${PREFIX}-showMore`,
  option: `${PREFIX}-option`,
}

const Root = styled(Grid)(() => ({
  fontSize: 14,
  [`& .${classes.group}`]: {
    borderTop: '1px solid #bdbdbd',
    borderBottom: '1px solid #bdbdbd',
    color: '#404041',
    padding: '5px 10px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'capitalize',
  },
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: '24px',
  },
  [`& .${classes.showMore}`]: {
    borderTop: '1px solid #bdbdbd',
    borderRadius: 0,
    textAlign: 'center',
    textTransform: 'unset',
    '&:hover': { backgroundColor: 'inherit' },
    fontSize: 14,
    padding: '0 16px',
  },
  [`& .${classes.option}`]: {
    lineHeight: 0.9,
  },
  '& .MuiAccordionSummary-root': {
    minHeight: '24px',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}))

function HeaderSearchGroup(props: ComponentProps): JSX.Element {
  const { t } = useTranslation()
  const [showMore, setShowMore] = useState(true)
  const { data } = props

  const showList =
    Array.isArray(data.children) && data.children.length ? (showMore ? data.children.slice(0, 5) : data.children) : []
  return (
    <Root>
      <Typography className={classes.group}>
        {data.group === HeaderSearchAssetType.prospects ? (
          <PersonIcon />
        ) : data.group === HeaderSearchAssetType.organizations ? (
          <BusinessOutlinedIcon />
        ) : (
          <AttachMoneyIcon />
        )}
        <Typography component="span" sx={{ px: '5px', fontWeight: 600, fontSize: 14 }}>
          {data.group}
        </Typography>
      </Typography>
      {Array.isArray(showList) && showList.length
        ? showList.map((option) => {
            return (
              <Grid key={option.key} className={classes.option}>
                <HeaderSearchOption
                  type={data.group}
                  id={option.key}
                  label={option.props.children[0].key}
                  email={option.props.children[1].key}
                />
              </Grid>
            )
          })
        : null}
      {showMore && Array.isArray(data.children) && data.children.length > 5 ? (
        <Button
          className={classes.showMore}
          fullWidth
          onClick={() => {
            setShowMore(false)
          }}
        >
          {t('showMore')}
        </Button>
      ) : null}
    </Root>
  )
}

export default HeaderSearchGroup
